<template>
  <div class="home">
    <div class="">
      <div class="row">
        <div>
          <div class="ui ">
            <h4>Select Client</h4>
            <div class="ui divider"></div>
            <div v-if="!showNewClientScreen">
              <form class="ui form" v-on:submit.prevent>
                <div class="field">
                  <sui-input
                    fluid
                    placeholder="Search ..."
                    v-model="searchText"
                    v-on:keyup="getResults(1)"
                  />
                </div>
              </form>
              <div v-if="message != ''" class="ui message">{{ message }}</div>
              <table class="ui compact table">
                <thead v-if="!loading">
                  <tr>
                    <th>Name</th>
                  </tr>
                </thead>
                <tbody v-if="!loading">
                  <tr v-for="c in finalResults" :key="c.id">
                    <td>
                      <a href="#" @click.prevent="selectClient(c.id)">{{
                        c.fullName
                      }}</a>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="loading">
                  <tr>
                    <td>
                      <span>
                        <div
                          class="hollow-dots-spinner"
                          v-if="loading"
                          :style="spinnerStyle"
                        >
                          <div class="dot"></div>
                          <div class="dot"></div>
                          <div class="dot"></div></div
                      ></span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <br />
              <div class="ui grid">
                <div>
                  <sui-menu
                    v-if="totalPages > 1"
                    style="float: right"
                    pagination
                  >
                    <a is="sui-menu-item" @click.prevent="getResults(1)" icon>
                      <sui-icon name="left chevron" />First Page
                    </a>
                    <a
                      is="sui-menu-item"
                      v-if="
                        currentPageNr - 4 > 0 && currentPageNr - 4 <= totalPages
                      "
                      @click.prevent="getResults(currentPageNr - 4)"
                      >{{ currentPageNr - 4 }}</a
                    >
                    <a
                      is="sui-menu-item"
                      v-if="
                        currentPageNr - 3 > 0 && currentPageNr - 3 <= totalPages
                      "
                      @click.prevent="getResults(currentPageNr - 3)"
                      >{{ currentPageNr - 3 }}</a
                    >
                    <a
                      is="sui-menu-item"
                      v-if="
                        currentPageNr - 2 > 0 && currentPageNr - 2 <= totalPages
                      "
                      @click.prevent="getResults(currentPageNr - 2)"
                      >{{ currentPageNr - 2 }}</a
                    >
                    <a
                      is="sui-menu-item"
                      v-if="
                        currentPageNr - 1 > 0 && currentPageNr - 1 <= totalPages
                      "
                      @click.prevent="getResults(currentPageNr - 1)"
                      >{{ currentPageNr - 1 }}</a
                    >
                    <div is="sui-menu-item">
                      <strong>{{ currentPageNr }}</strong>
                    </div>

                    <a
                      is="sui-menu-item"
                      v-if="
                        currentPageNr + 1 > 0 && currentPageNr + 1 <= totalPages
                      "
                      @click.prevent="getResults(currentPageNr + 1)"
                      >{{ currentPageNr + 1 }}</a
                    >
                    <a
                      is="sui-menu-item"
                      v-if="
                        currentPageNr + 2 > 0 && currentPageNr + 2 <= totalPages
                      "
                      @click.prevent="getResults(currentPageNr + 2)"
                      >{{ currentPageNr + 2 }}</a
                    >
                    <a
                      is="sui-menu-item"
                      v-if="
                        currentPageNr + 3 > 0 && currentPageNr + 3 <= totalPages
                      "
                      @click.prevent="getResults(currentPageNr + 3)"
                      >{{ currentPageNr + 3 }}</a
                    >
                    <a
                      is="sui-menu-item"
                      v-if="
                        currentPageNr + 4 > 0 && currentPageNr + 4 <= totalPages
                      "
                      @click.prevent="getResults(currentPageNr + 4)"
                      >{{ currentPageNr + 4 }}</a
                    >

                    <a
                      is="sui-menu-item"
                      icon
                      @click.prevent="getResults(totalPages)"
                    >
                      <sui-icon name="right chevron" />Last Page
                    </a>
                  </sui-menu>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getClientsV2, createClient, deleteClientV2 } from "@/gateway";
import moment from "moment";

export default {
  name: "ProposalList",
  props: {
    msg: String
  },
  data() {
    return {
      // new client
      message: "",
      clientFirstName: "",
      clientLastName: "",
      currentAge: 55,
      email: "",
      birthday: null,
      showNewClientScreen: false,
      //
      results: [],
      filterStatus: "Saved",
      searchText: "",
      orderBy: "updated_as_at",
      order: "desc",
      loading: false,
      totalRecords: 0,
      currentPageNr: 1,
      currentPageSize: 5,
      totalPages: 1,
      allRecords: {
        saved: 0,

        archived: 0
      }
    };
  },
  computed: {
    canSave() {
      if (
        this.clientFirstName != "" &&
        this.clientLastName != "" &&
        this.email != ""
      ) {
        return true;
      } else return false;
    },
    finalResults() {
      return this.results;
    },
    partnerBackgroundUrl() {
      if (this.$store.state.partnerBackgroundUrl)
        return this.$store.state.partnerBackgroundUrl;
      else return "";
    }
  },
  methods: {
    selectClient(id) {
      console.log("simple list", id);
      this.$emit("handleClientSelected", {
        clientId: id
      });
      console.log("emitted", {
        clientId: id
      });
    },
    calculateAge(arg) {
      return moment().diff(moment(arg, "YYYY-MM-DD"), "years");
    },
    formatDate(arg, fmt) {
      if (fmt) return moment(arg, "YYYY-MM-DD").format(fmt);
      else return moment(arg, "YYYY-MM-DD").format("DD MMM YYYY HH:mm");
    },
    friendlyDate(arg, fmt) {
      if (fmt) return moment(arg, "YYYYMMDD").format(fmt);
      else return moment(arg, "YYYYMMDD").format("DD MMM YYYY HH:mm");
    },
    async saveClient() {
      this.message = "";
      var response = await createClient({
        clientView: {
          id: 0,
          firstName: this.clientFirstName,
          lastName: this.clientLastName,
          primaryEmail: this.email,
          birthday: this.birthday
        }
      });
      if (response) {
        if (response.result == true) {
          this.$router.push("/v2/client/" + response.id);
        } else {
          this.message =
            response.result == true ? "Success" : "Error creating client";
          this.showNewClientScreen = false;
          this.init();
        }
      }
    },
    async refreshResults(orderBy, ord) {
      this.pageNr = 1;
      this.orderBy = orderBy;
      this.order = ord;
      this.getResults(1);
    },
    async getResults(pageNr, filterStatus) {
      if (filterStatus) this.filterStatus = filterStatus;
      this.loading = true;
      //  await new Promise(r => setTimeout(r, 2000));
      var response = await getClientsV2({
        searchText: this.searchText,
        pageSize: this.currentPageSize,
        pageNr: pageNr,
        filterStatus: this.filterStatus,
        partnerId: this.$store.state.partnerId,
        orderBy: this.orderBy,
        order: this.order
      });
      // console.log(response);
      this.totalRecords = response.totalRecords;
      this.totalPages = response.totalPages;
      this.currentPageNr = response.currentPageNr;
      this.results = response.result;
      this.loading = false;
    },
    async getResultCount(filterStatus) {
      var response = await getClientsV2({
        pageSize: 100000,
        pageNr: 1,
        filterStatus: filterStatus,
        partnerId: this.$store.state.partnerId
      });
      //   console.log(response.totalRecords);

      //    console.log(this.allRecords);
    },
    async archivePlan(id) {
      //  console.log(" archiving plan " + id);
      /* const response = await updatePlanStatus({ id: id, status: "Archived" });
      console.log(response);
      if ((response.success = 1)) {
        await this.getResults(1);
        await this.getResultCount("Saved");
        await this.getResultCount("Archived");
      }*/
    },
    async movePlanToSaved(id) {
      /* const response = await updatePlanStatus({ id: id, status: "Saved" });
      if ((response.success = 1)) {
        await this.getResults(1);
        await this.getResultCount("Saved");
        await this.getResultCount("Archived");
      }*/
    },
    async init() {
      this.allRecords.saved = 0;
      this.allRecords.archived = 0;
      await this.getResults(1);
    }
  },
  async mounted() {
    this.init();
    this.birthday = moment()
      .add(-45, "years")
      .format("YYYY-MM-DD");
  }
};
</script>
